import { ROUTE_ADMIN, ROUTE_AUTH } from '@klear/constants'
import { getAdminBaseUrl, getAuthBaseUrl } from '@klear/runtime-env'

export function legacyCrossHostTarget({
  pathname,
  search,
  hash
}: {
  pathname: string
  search: string
  hash: string
}): string | null {
  const remap = (route: string, base: string) =>
    pathname === `/${route}` || pathname.startsWith(`/${route}/`)
      ? `${base}${pathname.slice(route.length + 1)}${search}${hash}`
      : null
  return remap(ROUTE_ADMIN, getAdminBaseUrl()) ?? remap(ROUTE_AUTH, getAuthBaseUrl())
}
